function formatTime(value) {
  if (!value) {
    return "—";
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "—";
  }
  return date.toLocaleString();
}

export default function WeatherSchedulerJobTable({
  jobs = [],
  canManage = false,
  runningJobKey = null,
  onRunNow,
  onToggleEnabled,
  onEditInterval,
}) {
  if (!jobs.length) {
    return <p className="admin-muted">No scheduled weather jobs registered.</p>;
  }

  return (
    <div className="admin-table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            <th>Job</th>
            <th>Enabled</th>
            <th>Schedule</th>
            <th>Source</th>
            <th>Last run</th>
            <th>Next run</th>
            <th>Status</th>
            <th>Duration</th>
            <th>Failures</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => {
            const failing = (job.consecutiveFailures || 0) > 0;
            const statusClass = failing
              ? "admin-badge admin-badge--warning"
              : job.enabled
                ? "admin-badge admin-badge--success"
                : "admin-badge admin-badge--muted";

            return (
              <tr key={job.jobKey}>
                <td>
                  <strong>{job.jobName || job.jobKey}</strong>
                  <div className="admin-muted admin-table__sub">{job.jobKey}</div>
                </td>
                <td>
                  <span className={job.enabled ? "admin-badge admin-badge--success" : "admin-badge admin-badge--muted"}>
                    {job.enabled ? "Yes" : "Disabled"}
                  </span>
                </td>
                <td>{job.intervalMinutes ? `Every ${job.intervalMinutes} min` : "—"}</td>
                <td>{job.sourceKey || "—"}</td>
                <td>{formatTime(job.lastRunAt)}</td>
                <td>{formatTime(job.nextRunAt)}</td>
                <td>
                  <span className={statusClass}>{job.lastStatus || "—"}</span>
                  {job.lastError ? (
                    <div className="admin-muted admin-table__sub" title={job.lastError}>
                      {job.lastError}
                    </div>
                  ) : null}
                </td>
                <td>{job.lastDurationMs != null ? `${job.lastDurationMs} ms` : "—"}</td>
                <td>{job.consecutiveFailures ?? 0}</td>
                <td className="admin-table__actions">
                  {canManage ? (
                    <>
                      <button
                        type="button"
                        className="admin-btn admin-btn--sm"
                        disabled={runningJobKey === job.jobKey}
                        onClick={() => onRunNow?.(job)}
                      >
                        {runningJobKey === job.jobKey ? "Running…" : "Run now"}
                      </button>
                      <button
                        type="button"
                        className="admin-btn admin-btn--sm admin-btn--secondary"
                        onClick={() => onToggleEnabled?.(job)}
                      >
                        {job.enabled ? "Disable" : "Enable"}
                      </button>
                      <button
                        type="button"
                        className="admin-btn admin-btn--sm admin-btn--secondary"
                        onClick={() => onEditInterval?.(job)}
                      >
                        Edit interval
                      </button>
                    </>
                  ) : (
                    <span className="admin-muted">View only</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
